import * as _ from 'es-toolkit';
import { Utils } from '../services/';
import { normalize_new_trailer_for_api } from '../services/videoTrailer';

/** Base class for all models. */
class BaseModel {
    constructor(properties) {
        Object.assign(this, properties || {});
    }

    /**
     * Prepare this object for update.
     * This is used to "normalize", if needed, some properties
     * before to send them.
     *
     * return{BaseModel}
     */
    prepareForUpdate() {
        const prepared = _.cloneDeep(this);

        //clean general information on translatable
        Utils.cleanTranslatableProperty(prepared, "name");
        Utils.cleanTranslatableProperty(prepared, "description");

        //clean for posts translatable
        Utils.cleanTranslatableProperty(prepared, "title");
        Utils.cleanTranslatableProperty(prepared, "sub-title");
        Utils.cleanTranslatableProperty(prepared, "content");

        Utils.trimProperties(prepared);
        if (prepared.new_trailer && prepared.new_trailer_type) {
            prepared.new_trailer = normalize_new_trailer_for_api(
                prepared.new_trailer_type,
                prepared.new_trailer
            );
        }
        return prepared;
    }

    /**
     * Prepare this object for duplicate.
     * This is used to "normalize", if needed, some properties
     * before to send them.
     *
     * return{BaseModel}
     */
    prepareForDuplicate(_options) {
        const prepared = _.cloneDeep(this);
        return prepared;
    }
}

/**
 * Get the fields to get server side when we
 * ask for a listing
 */
BaseModel.getListingFields = () => [];

export default BaseModel;
